<div class="table" *ngIf="returnCode == 0">
    <table
        mat-table
        [dataSource]="dataSource"
        matSort
        (matSortChange)="onSort($event)"
        matSortActive="lastDebitDate"
        matSortDirection="asc"
        [matSortDisableClear]="true"
    >
        <!-- ID Column -->
        <ng-container matColumnDef="merchantName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">בית העסק</th>
            <td mat-cell *matCellDef="let row" (click)="openModal(row)">{{ row.merchantName }}</td>
        </ng-container>
        <ng-container matColumnDef="sourceCard">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">כרטיס</th>
            <td mat-cell *matCellDef="let row">{{ row.sourceCard }}</td>
        </ng-container>
        <ng-container matColumnDef="firstPurchaseDate" >
            <th class="date" mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">תאריך התחלה</th>
            <td class="date" mat-cell *matCellDef="let row">{{ row.firstPurchaseDate | date: 'dd.MM.yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="lastDebitDate" class="date">
            <th class="date" mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">תאריך חיוב אחרון</th>
            <td class="date" mat-cell *matCellDef="let row">{{ row.lastDebitDate | date: 'dd.MM.yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">סכום החיוב</th>
            <td mat-cell *matCellDef="let row">{{ row.amount | maxCurrency: 'ILS' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">סטטוס</th>
            <td mat-cell *matCellDef="let row" [innerHTML]="getStatusName(row)"></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="openModal(row)"></tr>
    </table>
</div>
<app-direct-debit-list-view-status [returnCode]="returnCode"></app-direct-debit-list-view-status>
<max-loader *ngIf="loader"></max-loader>
